import React from "react";

export default function SocialMediaUser({ title, name, value, register, children, onClick }) {

  return (
    <label className={`label-telefone ${value}`} onClick={onClick} >
      <input hidden type="radio" name={name} value={value} {...register(name)}/>
      <span><div className="mr-10">{children}</div> {title}</span>
    </label>
  );
}